const sources = ["barcode_page", "homepage", "seo_generator_page", "admin"];
let context = {};

export function setBarcodeAnalyticsContext(params) {
  context = { ...params, source: sources.includes(params.source) ? params.source : "barcode_page" };
}

export function trackBarcodeEvent(name, params = {}) {
  const payload = { ...context, ...params };
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", name, payload);
    } else {
      window.dataLayer = window.dataLayer || [];
      (function () { window.dataLayer.push(arguments); })("event", name, payload);
    }
  } catch (_) {
  }
}
